<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroRegulamento />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroRegulamento from "./../Components/Cadastros/CadastroRegulamento.vue";
export default {
  name: "RegisterRule",
  components: {
    CadastroRegulamento,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss'>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
